(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(leanProjectProgressSummaryConfig);


	function leanProjectProgressSummaryConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'leanProjectProgressSummary', {
				name: 'Project Progress Summary by Due Date',
				description: 'A visual summary of how lean projects are progressing',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/Task-Progress-Summary-by-Due-Date.png',
				categories: ['All', 'Lean Projects'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'leanProjectProgressSummaryCtrl',
				templateUrl: '/application/f/dashboard/widgets/lean-project-progress-summary.html',
				reload: true,
				isDrillDown: false
			}
		);
	}
})();
